/* eslint max-depth: "off", complexity: "off", camelcase: "off" */
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import Cleave from 'cleave.js/react'
import { cashflowDatumType } from '../common/types'
import PropTypes from 'prop-types'
import Error from '../common/Error'
import Loader from '../common/Loader'
import LoadingButton from '../common/LoadingButton'
import Tooltip from '../common/Tooltip'
import ModalHeader from '../common/ModalHeader'
import formatNumber from './helpers/formatNumber'
import FinanceUtil from './helpers/FinanceUtil'
import ProductsQuery from './queries/ProductsQuery'
import UpdateLoan from '../common/queries/UpdateLoan'
import UpsertOutstandingLoan from './queries/UpsertOutstandingLoan'
import unavailableProducts from "./helpers/unavailableProducts"

const Container = styled.div`
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background: white;
  width: 700px;
  max-height: calc(100% - 50px);
  overflow: scroll;
  position: relative;
`
const Section = styled.section`
  padding: 15px 30px 0px 30px;
  margin-top: 10px;
`
const SectionHeader = styled.h3`
  border-bottom: 1px solid #cecece;
  font-weight: bold;
`
const ProductSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const ProductSelect = styled.select`
  margin-bottom: 0;
  margin-left: 5px;
  height: 2em;
  width: auto;
`
const Grey = styled.p`
  color: #a0a0a0;
`
const MitigantList = styled.ul`
  list-style: none;
  padding: none;
`
const Label = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0px;
`
const CheckBox = styled.input`
  margin-top: 0px !important;
  margin-right: 7px !important;
`
const MitigantRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const Check = styled.i`
  border-radius: 100%;
  color: white;
  background: #47bd8c;
  padding: 1px;
  margin-right: 5px;
  width: 14px;
  height: 14px;
`
const X = styled.div`
  border-radius: 100%;
  color: white;
  background: red;
  padding: 1px;
  margin-right: 4px;
  font-weight: bold;
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const DebtHeader = styled.div`
  width: 100%;
  background: #f3f3f3;
  display: grid;
  grid-template-columns: .8fr 1fr 1fr 1.1fr .7fr;
`
const DebtRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: .8fr 1fr 1fr 1.1fr .7fr;
`
const DebtCell = styled.div`
  padding: 5px 10px;
  display: flex;
  align-items: center;
  ${props => props.center ? 'justify-self: center;' : ''}
  ${props => props.left ? 'justify-self: start;' : ''}
  ${props => props.right ? 'justify-self: end;' : ''}
  ${props => props.top ? 'align-self: start;' : ''}
  ${props => props.semiBold ? 'font-weight: bolder;' : ''}
`
const DSCRHeader = styled.div`
  display: grid;
  grid-template-columns: 1.7fr repeat(4, 1fr);
  background: white;
`
const DSCRTitle = styled.b`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
`
const Year = styled.div`
  padding-top: 10px;
  padding-right: 10px;
  text-align: right;
`
const DSCRRow = styled.div`
  display: grid;
  grid-template-columns: 1.7fr repeat(4, 1fr);
  background: #40baca;
  color: white;
  &:nth-of-type(4) {
    margin-top: 3px;
  }
`
const DSCRContainer = styled.div`
  border: 1px solid #e0e0e1;
`
const LoanAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const LoanAmountControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const LoanAmountInputContainer = styled.span`
  width: 91px;
  display: flex;
  height: 30px;
  position: relative;
  align-items: center;
  &::before {
    content: "$";
    position: absolute;
    left: 3px;
    display: flex;
    align-items: center;
    height: 100%;
    visibility: ${props => props.dollarSign ? 'visible' : 'hidden'};
  }
`
const LoanAmountInput = styled(Cleave)`
  text-align: center !important;
  width: 91px;
  border: 1px solid #cecfcf;
  border-radius: 4px;
  color: #56565a;
  margin-bottom: 0px !important;
`
const LoanAmount = styled.div`
  width: 100%;
  text-align: center;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
const Red = styled.p`
  color: #c4535e;
  margin: 0px 10px;
  ${props => !props.visible ? 'visibility: hidden;' : ''}
`
const Pencil = styled.i`
  background: #e2813b;
  color: white;
  cursor: pointer;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  border-radius: 50%;
  padding: 2px;
`
const Fees = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0px 130px;
`
const Fee = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const ButtonsContainer = styled.div`
  margin: 30px 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const GreyButton = styled.button`
  padding: 10px 20px;
  background: #dbdbdc;
  color: #6f6f73;
  border-radius: 3px;
  border: none;
`
const OrangeButton = styled(LoadingButton)`
  margin-left: 25px;
  position: static;
`
const Question = styled.div`
  display: inline-flex;
  border-radius: 100%;
  width: 10px;
  height: 13px;
  background: #f4f4f4;
  color: #888888;
  justify-content: center;
  align-items: center;
  cursor: default !important; /* It's hard to understand why this is necessary, but it is*/
  margin-left: 3px;
`
const TooltipContainer = styled.div` /* For some reason relative position prevents elements from repainting properly, so we use invisible containers for absolute positioned elements*/
  display: inline;
  position: relative;
  font-size: 13px;

`
const DebtTooltip = styled(Tooltip)`
  font-size: 13px;
  display: none;
  ${TooltipContainer}:hover & {
    display: inline;
  }
`
const mitigantText = {
  min_interim_business_dscr: 'Interim Business DSCR Above ${value}',
  min_interim_global_dscr: 'Interim Global DSCR Above ${value}',
  min_business_score: 'Lowest Business Credit Score Above ${value}',
  min_credit_score: 'Lowest Personal Credit Score Above ${value}',
  min_time_in_business: 'Time in Business Greater Than ${value} Years',
  min_tax_return_0_business_dscr: 'Most Recent Tax Year Business DSCR Above ${value}',
  min_tax_return_1_business_dscr: 'Prior Tax Year Business DSCR Above ${value}',
  min_tax_return_0_global_dscr: 'Most Recent Tax Year Business DSCR Above ${value}',
  min_tax_return_1_global_dscr: 'Prior Tax Year Global DSCR Above ${value}'
}
const smartBizProducts = ['SmartBiz - SBA', 'SmartBiz - CRE', 'SmartBiz - Conventional', 'SmartBiz - Paycheck Protection']

export class QuickLoanAnalysis extends React.Component {
  constructor(props) {
    super(props)
    const { loanAmount, product, entity, loan } = props
    const { outstandingLoans } = entity
    const loans = {}
    if (outstandingLoans) {
      for (const loan of outstandingLoans) {
        if (loan.active) {
          loans[loan.rid] = {
            ...loan
          }
        }
      }
    }
    this.state = {
      loans,
      financeUtil: new FinanceUtil(loanAmount, product, loan),
      isLoanAmountEditable: false,
      loading: false,
      currentProduct: smartBizProducts.includes(product.name) ? 'First Home - SBA' : product.name // If product is a SmartBiz placeholder, default to FHB
    }
  }
  static propTypes = {
    allCashflowData: PropTypes.arrayOf(cashflowDatumType).isRequired,
    data: PropTypes.shape({
      products: PropTypes.arrayOf(PropTypes.object)
    }),
    entity: PropTypes.object.isRequired,
    loan: PropTypes.object.isRequired,
    loanAmount: PropTypes.number.isRequired,
    product: PropTypes.object.isRequired,
    years: PropTypes.object.isRequired
  }
  componentDidMount() {
    this.forceUpdate()
  }
  getYears = () => {
    const { years } = this.props
    let taxYears = 0
    const y = Array.from(years.keys()).reverse()
    const applicableYears = []
    for (const year of y) {
      const { period } = years.get(year)
      if (period === 'tax') {
        taxYears += 1
      }
      applicableYears.unshift([year, period])
      if (taxYears === 2) {
        break
      }
    }
    return new Map([...applicableYears])
  }
  getShownYears = () => {
    const { years } = this.props
    const y = Array.from(years.entries())
    y.shift()
    return new Map(y)
  }
  get product() {
    const { props: { data: { products } }, state: { currentProduct } } = this

    return products.find(({ name }) => name === currentProduct) || {}
  }
  get outstandingLoanPayments() {
    const { loans } = this.state
    const { monthsRemainingCutoff } = this.product
    return Object.keys(loans).reduce((acc, key) => this.outstandingLoansReducer({ acc, key, loans, monthsRemainingCutoff }), 0) || 0
  }
  get finalDecision() {
    const { finalDecision = '{}' } = this.product

    return JSON.parse(finalDecision)
  }
  outstandingLoansReducer = ({ acc, key, loans, monthsRemainingCutoff }) => {
    const { refinance, monthlyPayment, monthsRemaining } = loans[key]
    if (!refinance && monthsRemaining > monthsRemainingCutoff) {
      return acc + monthlyPayment * 12
    }
    return acc
  }
  calculateBusinessDSCR = () => {
    const { entity } = this.props
    const { cashflowData } = entity
    const { financeUtil } = this.state
    const loanPayments = this.outstandingLoanPayments + financeUtil.monthlyPayment * 12
    return Array.from(this.getShownYears().keys()).map(year => {
      const cashAvailableDatum = cashflowData.find(datum => datum.year === year && datum.category === 'cash_available_for_debt_service')
      if (cashAvailableDatum && loanPayments > 0) {
        return {
          year,
          data: cashAvailableDatum.data / loanPayments
        }
      } else {
        return { data: null }
      }
    })
  }
  calculateGlobalDSCR = () => {
    const { allCashflowData, loan, entities } = this.props
    const { financeUtil } = this.state
    const { product } = this
    const loanLivingExpense = loan.product.livingExpense // Living expense from loan's current product
    const { livingExpense, federalTaxes, otherTaxes } = product
    let cashAvailable
    if (!product) {
      return []
    }
    const debtPaymentsCategories = ['total_annual_personal_loan_payments', 'existing_business_loan_payments']
    const guarantors = entities.filter(e => e.__typename === 'Guarantor')
    return Array.from(this.getShownYears().keys()).map(year => {
      let loanPayments = this.outstandingLoanPayments + financeUtil.monthlyPayment * 12
      loanPayments += allCashflowData.reduce((acc, datum) => { // sum annual debt payments from other entities
        const { category, data } = datum
        if (debtPaymentsCategories.includes(category) && datum.year === year) {
          acc += data
        }
        return acc
      }, 0) || 0
      const cashAvailableDatum = allCashflowData.find(datum => datum.year === year && datum.category === 'global_cashflow')
      if (cashAvailableDatum) {
        cashAvailable = cashAvailableDatum.data
      } else {
        return { data: null }
      }
      for (const guarantor of guarantors) {
        const federalTaxesDatum = guarantor.cashflowData.find(datum => datum.year === year && datum.category === 'federal_taxes')
        const realEstateTaxesDatum = guarantor.cashflowData.find(datum => datum.year === year && datum.category === 'real_estate_taxes') || { data: 0 }
        const stateTaxesDatum = guarantor.cashflowData.find(datum => datum.year === year && datum.category === 'state_taxes') || { data: 0 }
        const otherTaxesDatum = { data: realEstateTaxesDatum.data + stateTaxesDatum.data }
        if (federalTaxes && !loan.product.federalTaxes && federalTaxesDatum) {
          cashAvailable -= federalTaxesDatum.data
        } else if (!federalTaxes && loan.product.federalTaxes && federalTaxesDatum) {
          cashAvailable += federalTaxesDatum.data
        }
        if (otherTaxes && !loan.product.otherTaxes && otherTaxesDatum.data > 0) {
          cashAvailable -= otherTaxesDatum.data
        } else if (!otherTaxes && loan.product.otherTaxes && otherTaxesDatum.data > 0) {
          cashAvailable += otherTaxesDatum.data
        }
        // Subtract living expense from cash available based on product
        if (loanLivingExpense > livingExpense) {
          cashAvailable += loanLivingExpense - livingExpense
        } else if (loanLivingExpense < livingExpense) {
          cashAvailable -= livingExpense - loanLivingExpense
        }
      }
      if (cashAvailable && loanPayments > 0) {
        return {
          year,
          data: cashAvailable / loanPayments
        }
      } else {
        return { data: null }
      }
    })
  }
  onLoanRefi = (e, rid) => {
    const { loans } = this.state
    this.setState({
      loans: {
        ...loans,
        [rid]: {
          ...loans[rid],
          refinance: e.target.checked
        }
      }
    })
  }
  toggleLoanAmount = () => {
    this.setState({
      isLoanAmountEditable: !this.state.isLoanAmountEditable
    })
  }
  get isDisabled() {
    return this.blockProductChange || !this.isLoanAmountValidMinMax() || !this.isLoanAmountValidThousands()
  }
  get blockProductChange() {
    const {
      props: { product: { name, lenderKey }, loan: { hardCreditPulled } },
      state: { currentProduct },
      product: { lenderKey: lenderKeyP }
    } = this

    const isCreditPullValidForProductChange = !hardCreditPulled || this.isLenderSame(lenderKey, lenderKeyP)

    return !isCreditPullValidForProductChange && (name !== currentProduct)
  }
  isLenderSame = (current_lender, new_lender) => {
    return current_lender === new_lender
  }
  isLoanAmountValidMinMax = () => {
    const { props: { loanAmount }, product } = this
    let isValid = true

    if (product) {
      const { manualMax, manualMin } = product
      if (loanAmount > manualMax || loanAmount < manualMin) {
        isValid = false
      }
    }

   return isValid
  }
  isLoanAmountValidThousands = () => {
    return this.props.loanAmount % 1000 === 0
  }
  updateLoans = product => {
    // Filter loans and update state based on monthsRemainingCutoff
    const { loans } = this.state
    const { outstandingLoans } = this.props.entity
    const { products } = this.props.data
    const { monthsRemainingCutoff } = products.find(p => p.name === product)
    // Filter current applicable loans
    const filteredLoans = Object.entries(loans).filter(l => {
      const loan = l[0]
      return loan.monthsRemaining > monthsRemainingCutoff
    }).reduce((acc, val) => {
      const [rid, loan] = val
      acc[rid] = loan
      return acc
    }, {})
    for (const loan of outstandingLoans) {
      const { rid } = loan
      if (!(rid in filteredLoans) && loan.monthsRemaining > monthsRemainingCutoff) {
        filteredLoans[rid] = loan
      }
    }
    return filteredLoans
  }
  _updateOutstandingLoan = async (id, refinance) => {
    const { upsertOutstandingLoan, entity } = this.props
    await upsertOutstandingLoan({
      variables: {
        input: {
          outstandingLoanFields: {
            refinance
          },
          outstandingLoanId: id,
          businessId: entity.rid
        }
      }
    })
  }
  _updateLoan = async (rid, amount, product) => {
    const { updateLoan } = this.props
    await updateLoan({
      variables: {
        input: {
          rid,
          amount,
          productId: product
        }
      }
    })
  }
  onCloseClick = () => {
    this.props.toggleModal()
  }
  onLoanAmountChange = e => {
    const { changeLoanAmount, loan } = this.props
    const { product } = this
    let loanAmount = parseInt(e.target.rawValue, 10)
    if (Number.isNaN(loanAmount) || typeof loanAmount !== 'number') {
      loanAmount = 0
    }
    if (loanAmount <= product.manualMax) {
      this.setState({
        financeUtil: new FinanceUtil(loanAmount, product, loan)
      })
    }
    changeLoanAmount(loanAmount)
  }
  onApplyClick = async () => {
    const { changeModal, refetch, loanAmount, product } = this.props
    const { amount, rid } = this.props.loan
    const { outstandingLoans } = this.props.entity
    const { loans, currentProduct } = this.state
    let changed = false
    this.setState({
      loading: true
    })
    for (const outstandingLoan of outstandingLoans) {
      const { rid, refinance } = outstandingLoan
      if (loans[rid] && loans[rid].refinance !== refinance) { // make sure loan is in state before comparing (outstanding loans may include loans that aren't considered in DSCR calc)
        changed = true
        try {
          await this._updateOutstandingLoan(rid, loans[rid].refinance)
        } catch (err) {
          console.log(err)
        }
      }
    }
    if (amount !== loanAmount || product.name !== currentProduct) { // Check if loan amount or product have changed
      changed = true
      try {
        await this._updateLoan(rid, loanAmount, this.product.rid)
      } catch (err) {
        console.log(err)
      }
    }
    if (changed) {
      try {
        await refetch()
      } catch (err) {
        console.log(err)
      }
    }
    changeModal()
  }
  onProductChange = e => {
    const { loanAmount, loan } = this.props
    const { products } = this.props.data
    const product = products.find(p => p.name === e.target.value)
    this.setState({
      currentProduct: e.target.value,
      financeUtil: new FinanceUtil(loanAmount, product, loan),
      loans: this.updateLoans(e.target.value)
    })
  }
  onQuestionMouseOver = () => {
    this.setState({
      isQuestionHovered: true
    })
  }
  onQuestionMouseOut = () => {
    this.setState({
      isQuestionHovered: false
    })
  }
  renderMinDSCRsByKey = (key, idx) => { // TODO: Refactor this
    const { finalDecision } = this
    const applicableYears = this.getYears()

    const mitigants = this.flattenMitigants()
    let taxYears = 0
    let changed = false
    const cells = Array.from(applicableYears.keys()).reverse().map(year => {
      const period = applicableYears.get(year)
      if (finalDecision[key]) {
        let minDSCR
        const yearKey = period === 'interim' ? 'interim_year' : `tax_return_${taxYears}`
        const { tolerable } = finalDecision[key][yearKey]
        minDSCR = finalDecision[key][yearKey].min_dscr
        if (tolerable && tolerable[idx]) {
          const { mitigating_factors, num_mitigating_factors_min, min_dscr } = tolerable[idx]
          let satisfied = 0
          let requiredCount = 0
          let requiredSatisfied = 0
          for (const mitigant in mitigating_factors) {
            const { value, required } = mitigating_factors[mitigant]
            if (required === 'true') {
              requiredCount += 1
            }
            if (this.checkMitigant(mitigants, yearKey, mitigant, value)) {
              satisfied += 1
              if (required === 'true') {
                requiredSatisfied += 1
              }
            }
          }
          if (satisfied >= num_mitigating_factors_min && requiredSatisfied >= requiredCount) {
            changed = true
            minDSCR = min_dscr
          }
        }
        if (period === 'tax') {
          taxYears += 1
        }
        return (
          <DebtCell key={`${year}-${yearKey}`} right>
            {minDSCR ? minDSCR.toFixed(2) : null}
          </DebtCell>
        )
      } else {
        return <DebtCell key={`${year}-blank`} />
      }
    }).reverse()
    if (applicableYears.size < 4) {
      for (let i = 0; i < 4 - applicableYears.size; i++) {
        cells.unshift(
          <DebtCell key={`debt-cell-${i}`} />
        )
      }
    }
    if (!changed && idx === 1) {
      return null
    }
    return cells
  }
  renderMinDSCRs = () => {
    const { loading } = this.props.data
    if (!loading) {
      const { product: { name } } = this
      const applicableYears = this.getYears()

      const busDSCRs1 = this.renderMinDSCRsByKey('business_dscr', 0)
      const busDSCRs2 = this.renderMinDSCRsByKey('business_dscr', 1)
      const globalDSCRs1 = this.renderMinDSCRsByKey('global_dscr', 0)
      const globalDSCRs2 = this.renderMinDSCRsByKey('global_dscr', 1)

      return (
        <DSCRContainer id="tinker_tool_min_dscrs">
          <DSCRHeader>
            <DSCRTitle>
              {name}
            </DSCRTitle>
            {
              Array.from(this.getShownYears().keys()).map(year => (
                <Year key={`min-dscr-${year}`}>
                  <b>{year}</b> <br />
                  {applicableYears.get(year) === 'interim' && <small>Interim</small>}
                </Year>
              ))
            }
          </DSCRHeader>
          <DSCRRow>
            <DebtCell semiBold right>
              Min Business DSCR
            </DebtCell>
            {busDSCRs1}
          </DSCRRow>
          <DSCRRow>
            <DebtCell semiBold right>
              Min Global DSCR
            </DebtCell>
            {globalDSCRs1}
          </DSCRRow>
          {(() => { // Immediately-invoked function to determine whether or not to show a second pair of DSCR Rows - not great but it works
            let row1 = null, row2 = null
            if (busDSCRs2 === null && globalDSCRs2 !== null) {
              row1 = busDSCRs1
              row2 = globalDSCRs2
            } else if (busDSCRs2 !== null && globalDSCRs2 === null) {
              row1 = busDSCRs2
              row2 = globalDSCRs1
            } else if (busDSCRs2 !== null && globalDSCRs2 !== null) {
              row1 = busDSCRs2
              row2 = globalDSCRs2
            }
            if (row1 === null && row2 === null) {
              return null
            } else {
              return (
                <Fragment>
                  <DSCRRow>
                    <DebtCell semiBold right>
                      Min Business DSCR
                    </DebtCell>
                    {row1}
                  </DSCRRow>
                  <DSCRRow>
                    <DebtCell semiBold right>
                      Min Global DSCR
                    </DebtCell>
                    {row2}
                  </DSCRRow>
                </Fragment>
              )
            }
          })()}
        </DSCRContainer>
      )
    }
  }
  renderProducts = () => {
    const { data, product } = this.props
    if (data.loading) {
      return <option id={product.name} value={product.name}>{product.name}</option>
    } else {
      return data.products.filter((p) => !unavailableProducts(p.name)).sort((a, b) => a.name.localeCompare(b.name)).map(prod => {
        const { rid, name } = prod
        
        return <option id={name} key={rid} value={name}>{name}</option>
      })
    }
  }
  checkMitigant = (mitigants, year, type, value) => {
    const { entity, entities, years } = this.props
    const mitigant = mitigants.find(m => year ? m.year === year : true && m.value === value)
    const guarantors = entities.filter(e => e.__typename === 'Guarantor')
    const interimYears = Array.from(years.keys()).filter(year => years.get(year).period === 'interim')
    const taxYears = Array.from(years.keys()).filter(year => years.get(year).period === 'tax')
    const globalDSCRs = this.calculateGlobalDSCR()
    const businessDSCRs = this.calculateBusinessDSCR()
    if (mitigant) {
      let year, datum
      switch (type) {
        case 'min_business_score':
          return entity.businessScore >= value
        case 'min_credit_score':
          return guarantors.length > 0 ? guarantors.every(g => g.creditScore >= value) : false // Array.every returns true for empty arrays, so we need to define behavior for that case
        case 'min_time_in_business':
          return entity.timeInBusiness >= value
        case 'min_interim_global_dscr':
          return interimYears.length > 0 ? interimYears.every(year => {
            datum = globalDSCRs.find(datum => datum.year === year)
            return datum ? datum.data >= value : false
          }) : false
        case 'min_interim_business_dscr':
          return interimYears.length > 0 ? interimYears.every(year => {
            datum = businessDSCRs.find(datum => datum.year === year)
            return datum ? datum.data >= value : false
          }) : false
        case 'min_tax_return_0_business_dscr':
          year = taxYears[taxYears.length - 1]
          datum = businessDSCRs.find(datum => datum.year === year)
          return datum ? datum.data >= value : false
        case 'min_tax_return_1_business_dscr':
          year = taxYears[taxYears.length - 2]
          datum = businessDSCRs.find(datum => datum.year === year)
          return datum ? datum.data >= value : false
        case 'min_tax_return_0_global_dscr':
          year = taxYears[taxYears.length - 1]
          datum = globalDSCRs.find(datum => datum.year === year)
          return datum ? datum.data >= value : false
        case 'min_tax_return_1_global_dscr':
          year = taxYears[taxYears.length - 1]
          datum = globalDSCRs.find(datum => datum.year === year)
          return datum ? datum.data >= value : false
        default:
          return false
      }
    }
    return false
  }
  flattenMitigants = () => {
    const { global_dscr, business_dscr } = this.finalDecision
    const mitigants = []

    if (global_dscr) {
      for (const year in global_dscr) {
        const { tolerable } = global_dscr[year]
        if (tolerable) {
          for (const entry of tolerable) { // tolerable is an array
            const { mitigating_factors } = entry
            if (mitigating_factors) {
              for (const mitigant in mitigating_factors) {
                const { value } = mitigating_factors[mitigant]
                mitigants.push({ year, type: mitigant, value })
              }
            }
          }
        }
      }
    }
    if (business_dscr) {
      for (const year in business_dscr) {
        const { tolerable } = business_dscr[year]
        if (tolerable) {
          for (const entry of tolerable) { // tolerable is an array
            const { mitigating_factors } = entry
            if (mitigating_factors) {
              for (const mitigant in mitigating_factors) {
                const { value } = mitigating_factors[mitigant]
                mitigants.push({ year, type: mitigant, value })
              }
            }
          }
        }
      }
    }

    return mitigants
  }
  renderMitigants = () => {
    const mitigants = this.flattenMitigants()
    const rendered = []
    const processed = []
    for (const mitigant of mitigants) {
      const { type } = mitigant
      if (!processed.includes(type)) {
        const { value } = mitigant
        const satisfied = this.checkMitigant(mitigants, null, type, value)
        const copy = mitigantText[type].replace('${value}', value) // use eval to inject value into string...against my better judgement
        processed.push(mitigant.type)
        rendered.push(
          <MitigantRow key={`mitigant-row-${mitigant.year}-${mitigant.type}`}>
            {satisfied ? <Check className="fa fa-check" /> : <X>X</X>}
            <span>{copy}</span>
          </MitigantRow>
        )
      }
    }
    return rendered
  }
  renderDebts = () => {
    const { loans } = this.state
    if (Object.keys(loans).length > 0) {
      const rows = Object.keys(loans).map((rid, i) => {
        const { lender, principalBalance, monthlyPayment, refinance, monthsRemaining } = loans[rid]
        return (
          <DebtRow key={`loan-${rid}`}>
            <DebtCell>
              {lender}
            </DebtCell>
            <DebtCell center>
              {`$${formatNumber(principalBalance)}`}
            </DebtCell>
            <DebtCell center>
              {`$${formatNumber(monthlyPayment)}`}
            </DebtCell>
            <DebtCell center>
              {monthsRemaining}
            </DebtCell>
            <DebtCell center>
              <Label>
                <CheckBox
                  type="checkbox"
                  checked={refinance}
                  label="Refinance"
                  onChange={e => this.onLoanRefi(e, rid)}
                  id={`quick_loan_analysis_refinance_${i}`}
                />
                Refinance
              </Label>
            </DebtCell>
          </DebtRow>
        )
      })
      return (
        <Fragment>
          <h4>
            Debts
            <TooltipContainer>
              <Question
                className="fa fa-question-circle"
                innerRef={node => this.question = node}
                onMouseOver={this.onQuestionMouseOver}
                onMouseOut={this.onQuestionMouseOut}
              />
              <DebtTooltip left={12} bottomEdge={16}>
                Refinancing a debt will exclude it from DSCR calculations
              </DebtTooltip>

            </TooltipContainer>
          </h4>
          <DebtHeader>
            <DebtCell>
              Lender
            </DebtCell>
            <DebtCell center>
              Balance
            </DebtCell>
            <DebtCell center>
              Monthly Payment
            </DebtCell>
            <DebtCell>
              Payments Remaining
            </DebtCell>
          </DebtHeader>
          {rows}
        </Fragment>
      )
    }
  }
  renderSimulatedDSCR = () => {
    const { years } = this.props
    const businessDSCR = this.calculateBusinessDSCR()
    const globalDSCR = this.calculateGlobalDSCR()
    const businessDSCRRow = businessDSCR.map((datum, i) => {
      return <DebtCell key={`business-dscr-${i}`} right>{datum.data ? datum.data.toFixed(2) : null}</DebtCell>
    })
    const globalDSCRRow = globalDSCR.map((datum, i) => {
      return <DebtCell key={`global-dscr-${i}`} right>{datum.data ? datum.data.toFixed(2) : null}</DebtCell>
    })
    const y = Array.from(this.getShownYears().keys()).map(year => {
      return (
        <Year key={`simulated-dscr-${year}`}>
          <b>{year}</b>
          <br />
          {years.get(year).period === 'interim' && <small>Interim</small>}
        </Year>
      )
    })
    return (
      <Fragment>
        <h4>Debt Service Coverage Ratio</h4>
        <DSCRContainer id="tinker_tool_simulated_dscrs">
          <DSCRHeader>
            <div />
            {y}
          </DSCRHeader>
          <DSCRRow>
            <DebtCell semiBold right>Business DSCR</DebtCell>
            {businessDSCRRow}
          </DSCRRow>
          <DSCRRow>
            <DebtCell semiBold right>Global DSCR</DebtCell>
            {globalDSCRRow}
          </DSCRRow>
        </DSCRContainer>
      </Fragment>
    )
  }
  renderLoanAmount = () => {
    const { loanAmount } = this.props
    const { isLoanAmountEditable } = this.state
    if (isLoanAmountEditable) {
      const cleaveOptions = {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralPositiveOnly: true,
        stripLeadingZeroes: true,
        numeralDecimalScale: 0
      }
      return (
        <LoanAmountInputContainer dollarSign={isLoanAmountEditable}>
          <LoanAmountInput
            options={cleaveOptions}
            id="tinker_tool_loan_amount"
            value={loanAmount.toLocaleString('en')}
            onChange={this.onLoanAmountChange}
          />
        </LoanAmountInputContainer>
      )
    } else {
      return (
        <LoanAmountInputContainer dollarSign={isLoanAmountEditable}>
          <LoanAmount>
            ${formatNumber(loanAmount)}
          </LoanAmount>
        </LoanAmountInputContainer>
      )
    }
  }
  renderLoanAnalysis = () => {
    const { state: { financeUtil }, product } = this
    const { manualMin, manualMax } = product

    return (
      <Section id="tinker_tool_loan_analysis">
        <SectionHeader>
          Loan Analysis
        </SectionHeader>
        <Grey>
          Use the simulator below to check business and global DSCRs at different loan amounts with different refinance options.
        </Grey>
        <LoanAmountContainer>
          <h3>What loan amount do you want to try?</h3>
          <LoanAmountControls>
            <Pencil id="tinker_tool_edit_loan_amount" className="fa fa-pencil" onClick={this.toggleLoanAmount} />
            {this.renderLoanAmount()}
          </LoanAmountControls>
          <Red visible={!this.isLoanAmountValidMinMax()}>
            The loan amount must be between {`$${formatNumber(manualMin)}`} to {`$${formatNumber(manualMax)}`}.
          </Red>
          <Red visible={!this.isLoanAmountValidThousands()}>
            The loan amount must be in increments of $1,000
          </Red>
        </LoanAmountContainer>
        <Fees>
          <Fee>
            <p>Monthly Payment</p>
            <Grey>${formatNumber(Math.round(financeUtil.monthlyPayment))}</Grey>
          </Fee>
          <Fee>
            <p>SmartBiz Fee</p>
            <Grey>${formatNumber(Math.round(financeUtil.packagingFees + financeUtil.referralFees))}</Grey>
          </Fee>
          <Fee>
            <p>Bank Fee</p>
            <Grey>${formatNumber(Math.round(financeUtil.guarantyFees + financeUtil.fixedFees))}</Grey>
          </Fee>
        </Fees>
      </Section>
    )
  }
  renderButtons = () => {
    return (
      <ButtonsContainer>
        <GreyButton id="tinker_tool_do_not_apply" onClick={this.onCloseClick}>
          Do not apply updates
        </GreyButton>
        <OrangeButton
          id="tinker_tool_apply"
          disabled={this.isDisabled}
          loading={this.state.loading}
          onClick={this.onApplyClick}
        >
          Apply updates to this application
        </OrangeButton>
      </ButtonsContainer>
    )
  }
  renderHeader = () => {
    return <ModalHeader text="Quick Loan Analysis" onClose={this.onCloseClick} closeButtonId="tinker_tool_close" />
  }
  render() {
    const { loading, error } = this.props.data
    if (error) {
      return (
        <Container>
          {this.renderHeader()}
          <Error />
        </Container>
      )
    }
    if (loading) {
      return (
        <Container>
          {this.renderHeader()}
          <Loader number={4} />
        </Container>
      )
    }
    return (
      <Container innerRef={node => this.container = node}>
        {this.renderHeader()}
        <Section>
          <SectionHeader>Lender Requirements for This Loan</SectionHeader>
          <ProductSelectContainer>
            {'Lender Selected: '}
            <ProductSelect id="product_select" value={this.state.currentProduct} onChange={this.onProductChange}>
              {this.renderProducts()}
            </ProductSelect>
          </ProductSelectContainer>
          <p>Below are all of the possible mitigants to DSCR for the assigned lender and the corresponding minimum DSCRs required per credit policy.</p>
          <MitigantList id="tinker_tool_dscr_mitigants">
            {this.renderMitigants()}
          </MitigantList>
          {this.renderMinDSCRs()}
        </Section>
        {this.renderLoanAnalysis()}
        <Section id="tinker_tool_debts">
          {this.renderDebts()}
          {this.renderSimulatedDSCR()}
        </Section>
        <Section>
          {this.renderButtons()}
        </Section>
      </Container>
    )
  }
}
export default compose(
  graphql(ProductsQuery, {
    options: OwnProps => ({
      variables: {
        category: ['working_capital', 'cre', 'paycheck_protection'],
        loanId: parseInt(OwnProps.loan.rid, 10)
      }
    })
  }),
  graphql(UpsertOutstandingLoan, {
    name: 'upsertOutstandingLoan'
  }),
  graphql(UpdateLoan, {
    name: 'updateLoan'
  })
)(QuickLoanAnalysis)
